import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { BuildingTypeService } from 'src/app/core/services/buildingType/building-type.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddClientComponent } from 'src/app/shared/components/add-client/add-client.component';
import { DynamicServices } from 'src/app/features/ayen-services/services/dynamic-services/dynamic-services.service';
import { OrderType } from 'src/app/models/enums/order-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { BuildingType } from 'src/app/models/enums/building-type.enum';
import { AyenServices } from 'src/app/core/services/ayen-services/ayen-services.service';
import { ClientsService } from 'src/app/features/customers/services/clients.service';
import { ProjectsService } from 'src/app/features/projects/services/projects.service';
import { AdminOrdersService } from '../../../services/orders/admin-orders.service';
import { ScriptService } from 'src/app/core/services/script/script.service';
import { AyenMapComponent } from 'ayen-google-map';
import { LocationsService } from 'src/app/core/services/locations/locations.service';
import { District } from 'src/app/shared/Models/locations.model';
import { CompanyServicesService } from 'src/app/features/companies/services/company-services/company-services.service';
import { DropdownOption } from 'src/app/shared/Models/dropdown-option.model';
import { ReProjectsService } from 'src/app/features/re-projects/services/re-projects.service';

@Component({
  selector: 'app-build-details',
  templateUrl: './build-details.component.html',
  styleUrls: ['./build-details.component.scss'],
})
export class BuildDetailsComponent implements OnInit {
  @Output() building_view = new EventEmitter();
  orderId;
  order;
  buildingDetailsFormGroup: UntypedFormGroup;
  clients: any[] = [];
  buildingTypes;
  @ViewChild('client') client: NgSelectComponent;
  @ViewChild('buildingUnit') buildingUnit: NgSelectComponent;
  @ViewChild('orderTypeField') orderTypeField: NgSelectComponent;
  showAlertMsg: boolean = false;
  uploading?: boolean = false;
  is_test: boolean = false;
  params = '?page=';
  page: number = 1;
  page_count: number = 0;
  searchInput: any;
  timeout: any = null;
  projects: any = [];
  buildingType = BuildingType;
  currentParams: any = { page: 1 };
  private onScroll = (event: any) => {
    if (
      this.client?.isOpen ||
      this.buildingUnit?.isOpen ||
      this.orderTypeField?.isOpen
    ) {
      const isScrollingInScrollHost =
        (event.target.className as string).indexOf('ng-dropdown-panel-items') > -1;
      if (isScrollingInScrollHost) return;
      this.client.close();
      this.buildingUnit.close();
      this.orderTypeField.close();
    }
  };

  public clientDialogRef: MatDialogRef<AddClientComponent>;
  pageCount: any;
  projectsList = [];
  servicesList = [];
  selectedContract: any;
  orderType = OrderType;
  orderTypes: any;
  originalOrderTypes: any;
  services: any;
  servicesPageCount: any;
  selectedService: any;
  alertMessage: string = 'برجاء ادخال الحقول المطلوبة';
  projectId: any;
  referenceNumberList: any = [];
  mainOrders: any[] = [];
  refrencePageCount: any;
  selectedRefrenceNumber: any;
  clientGoals: any;
  districts: District[] = [];
  companies: DropdownOption[] = [];
  reProjects: any[] = [];
  // Pagination for companies
  companiesPage: number = 1;
  companiesPageCount: number = 0;
  companiesSearchTerm: string = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private buildingTypeService: BuildingTypeService,
    private clientsService: ClientsService,
    private ayenServices: AyenServices,
    private orderService: AdminOrdersService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private dynamicServices: DynamicServices,
    private projectService: ProjectsService,
    private company: CompanyServicesService,
    private reProjectsService: ReProjectsService,
    private location: LocationsService,
  ) {}

  handleBackendError(_error: any): void {
    try {
    } catch {}
  }

  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
    this.clients = [];
    this.getBuildingType();
    this.getBasicServices();
    this.getClientGoals();
    this.loadCompanies();
    this.route.queryParams.subscribe((params) => {
      this.orderId = +params.id;
      if (this.orderId) {
        this.getAdminOrder();
      }
      this.projectId = params.contract;
      if (this.projectId) {
        this.getProjectByID(this.projectId);
      }
    });
    window.addEventListener('scroll', this.onScroll, true);
  }

  getProjectByID(projectID: any) {
    this.projectService.getProjectByID(projectID).subscribe(
      (data) => {
        this.getProjectsByParams({ params: { page: 1, name: data.name }, clearList: true });
        this.buildingDetailsFormGroup.get('contract').setValue(projectID);
        const filterList = data.services;
        this.filterOrderTypes(filterList);
        if (data.company.owner) {
          this.setClient(data.company.owner);
        }
      },
      () => {},
    );
  }

  loadCompanies(searchTerm: string = '') {
    const params: any = { page: this.companiesPage, page_size: 20 };
    if (searchTerm) {
      params.query = searchTerm;
    }

    this.company.getCompaniesList(params).subscribe(
      (response: any) => {
        if (this.companiesPage === 1) {
          this.companies = response?.results || [];
        } else {
          this.companies = [...this.companies, ...(response?.results || [])];
        }
        this.companiesPageCount = response?.pages_count || 0;
      },
      (error) => console.error('Error loading companies:', error),
    );
  }

  onCompanyScroll() {
    if (this.companiesPage < this.companiesPageCount) {
      this.companiesPage++;
      this.loadCompanies(this.companiesSearchTerm);
    }
  }

  onCompanySearch(event: any) {
    this.companiesSearchTerm = event.term || '';
    this.companiesPage = 1;
    this.loadCompanies(this.companiesSearchTerm);
  }

  companyChanged(event: any) {
    this.getREProjects(event);
  }

  getREProjects(id: number) {
    this.reProjectsService.getCompanyREProjects(id).subscribe(
      (data) => {
        this.reProjects = data.data || data;
      },
      (error) => {
        console.error('Error loading RE projects:', error);
        this.reProjects = [];
      }
    );
  }

  filterOrderTypes(service?: any) {
    this.orderTypes = service
      ? this.originalOrderTypes.filter((item) => service.includes(item.pk))
      : this.originalOrderTypes;
  }

  setClient(id) {
    let params = { id: id };
    this.clientsService.getAllClients(params).subscribe(
      (data) => {
        this.clients.push(...data.results);
        this.page_count = data.pages_count;
        this.buildingDetailsFormGroup.patchValue({ order_client: Number(id) });
      },
      () => {},
    );
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
  }

  getAdminOrder() {
    this.orderService.getAdminOrder(this.orderId).subscribe(
      (data) => {
        this.order = data;
        this.is_test = this.order.is_test;
        this.patchValues();
      },
      () => {},
    );
  }

  patchValues() {
    if (this.order?.order_details?.order_client_object?.id) {
      let obj = {
        id: this.order.order_details.order_client_object.id,
        full_name: this.order.order_details.order_client_object.name,
      };
      this.clients = [];
      this.clients.push(obj);
    }
    if (this.order.contract?.pk) {
      this.projectsList = [];
      let contractObj = { id: this.order.contract.pk, name: this.order.contract.name };
      this.projectsList.push(contractObj);
      this.selectedContract = this.order.contract.pk;
    }
    if (this.order.linked_order) {
      this.referenceNumberList = [];
      let refrenceObj = {
        id: this.order.linked_order.id,
        reference_number: this.order.linked_order.reference_number,
      };
      this.referenceNumberList.push(refrenceObj);
      this.selectedRefrenceNumber = this.order.linked_order.id;
    }
    if (this.order.dynamic_service) {
      this.servicesList = [];
      let contractObj = {
        id: this.order.order_details.dynamic_service.id,
        name: this.order.order_details.dynamic_service.name,
      };
      this.servicesList.push(contractObj);
      this.selectedService = this.order.dynamic_service;
    }
    this.changeOrderType(this.order.order_type);

    this.buildingDetailsFormGroup.patchValue({
      reference_number: this.order.reference_number === 'null' ? ' ' : this.order.reference_number,
      order_client: this.order.order_details.order_client_object
        ? this.order.order_details.order_client_object.id
        : null,
      building_type: this.order.building_type,
      custom_property_type: this.order.building_data?.custom_property_type,
      initial_space: this.order.initial_space,
      contract: this.order.contract?.pk,
      is_test: this.order.is_test,
      allow_order_notifications: this.order.allow_order_notifications,
      order_type: this.order.order_type,
      dynamic_service: this.order.dynamic_service,
      has_attached_building: this.order.has_attached_building,
      floors_number: this.order.floors_number,
      linked_order: this.order?.linked_order?.id,
      client_goal: this.order.client_goal,
    });
  }

  createFormControls() {
    return this.buildingDetailsFormGroup.controls;
  }

  createForm() {
    this.buildingDetailsFormGroup = this.formBuilder.group({
      reference_number: [null],
      order_client: new UntypedFormControl(null, Validators.required),
      building_type: [null, Validators.required],
      custom_property_type: [null],
      initial_space: [null],
      contract: [null],
      is_test: [false, Validators.required],
      allow_order_notifications: [true],
      order_type: [null, Validators.required],
      dynamic_service: [null],
      has_attached_building: [false],
      floors_number: [null],
      linked_order: [null],
      client_goal: [null, Validators.required],
      linked_real_estate_project_developer: [null],
      linked_real_estate_project: [null],
    });
  }

  changeOrderType(event: any) {
    if (event === this.orderType.DynamicServices) {
      this.setRequiredValidatorVal('dynamic_service');
    } else {
      this.changeFormControlValidators('dynamic_service');
    }
  }

  setRequiredValidatorVal(formControl) {
    this.buildingDetailsFormGroup.controls[formControl].setValidators(Validators.required);
    this.buildingDetailsFormGroup.controls[formControl].updateValueAndValidity();
  }

  changeFormControlValidators(formControl) {
    this.buildingDetailsFormGroup.controls[formControl].clearValidators();
    this.buildingDetailsFormGroup.controls[formControl].updateValueAndValidity();
  }

  getBasicServices() {
    this.ayenServices.getAyenServices().subscribe(
      (data) => {
        this.originalOrderTypes = data;
        this.filterOrderTypes();
      },
      () => {},
    );
  }

  getDynamicServices(params) {
    let servicesParams = { ...params.params };
    servicesParams['is_active'] = true;
    if (params.clearList) {
      this.services = [];
      this.setServiceData(null);
    }
    let contract = this.buildingDetailsFormGroup.get('contract').value;
    if (contract) {
      servicesParams['contract'] = contract;
    }
    this.dynamicServices.getServices(servicesParams).subscribe(
      (data) => {
        this.services.push(...data.results);
        this.servicesList = [...this.services];
        this.servicesPageCount = data.pages_count;
      },
      () => {},
    );
  }

  buildingTypeChanged(buildingType) {
    if (buildingType === this.buildingType.Other) {
      this.setRequiredValidatorVal('custom_property_type');
    } else {
      this.changeFormControlValidators('custom_property_type');
    }
  }

  getBuildingType() {
    this.buildingTypeService.getBuildingTypes().subscribe(
      (data) => { this.buildingTypes = data; },
      () => {},
    );
  }

  getDistrictsByCity(cityId: number) {
    this.location.getDistrictsByCityPK(cityId).subscribe(
      (data) => {
        this.districts = data;
      },
      (error) => {
        this.handleBackendError(error);
      },
    );
  }

  getClients(page) {
    this.clientsService.getAllClients(page).subscribe(
      (data) => {
        this.clients.push(...data.results);
        this.page_count = data.pages_count;
      },
      () => {},
    );
  }

  getProjects(params) {
    this.projectService.getProjects(params.params).subscribe(
      (data) => {
        this.projects.push(...data.results);
        this.projectsList = [...this.projects];
        this.pageCount = data.pages_count;
        if (this.projectId) {
          this.selectedContract = Number(this.projectId);
        }
      },
      () => {},
    );
  }

  searchtext() {
    this.searchInput = this.client.searchTerm;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let params: any = {};
      if (this.searchInput) {
        params = { full_name: this.searchInput, ordering: 'full_name' };
      } else {
        params = { page: 1 };
      }
      this.clients = [];
      this.getClients(params);
    }, 600);
  }

  resetSearch() {
    this.clients = [];
    this.page = 1;
    this.currentParams = { page: 1 };
    this.getClients(this.currentParams);
  }

  onScrollPagination() {
    if (this.page < this.page_count) {
      this.page++;
      const params = { ...this.currentParams, page: this.page };
      this.getClients(params);
    }
  }

  getProjectsByParams(params) {
    if (params.clearList) {
      this.projects = [];
      this.setProjectData(null);
    }
    this.getProjects(params);
  }

  setProjectData(project) {
    this.buildingDetailsFormGroup.get('contract').setValue(project?.pk);
    if (project) {
      const service = project.services ?? null;
      this.filterOrderTypes(service);
    } else {
      this.filterOrderTypes();
    }
  }

  setServiceData(service) {
    this.buildingDetailsFormGroup.get('dynamic_service').setValue(service?.id);
  }

  save() {
    if (this.buildingDetailsFormGroup.status == 'INVALID') {
      this.showAlertMsg = true;
      let fields = document.querySelectorAll('ng-select.ng-invalid , input.ng-invalid');
      fields.forEach((field) => {
        field.parentElement?.classList.add('invalid-field');
      });
      return;
    }
    this.uploading = true;
    let orderUpdated = {};
    orderUpdated = this.buildingDetailsFormGroup.value;
    orderUpdated['utm_source'] = 'Manual';
   
    if (this.orderId) {
      this.updateOrder(orderUpdated);
    } else {
      this.createNewOrder(orderUpdated);
    }
  }

  createNewOrder(order) {
    this.orderService.createNewOrder(order).subscribe(
      (data) => { this.addOrder(data.id, data.dynamic_service); },
      (error) => {
        try {
          this.showAlertMsg = true;
          this.alertMessage = Object.values(error.error)[0].toString();
        } catch {}
        this.uploading = false;
      },
    );
  }

  addOrder(id, dynamicService?: number | null) {
    let params = { id: id };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: '',
    });
    this.uploading = false;
    this.building_view.emit({ view: 'address', id: id, dynamic_service: dynamicService ?? null });
  }

  updateOrder(order) {
    this.orderService.updateOrder(this.orderId, order).subscribe(
      (data) => { this.addOrder(data.id); },
      (error) => {
        try {
          this.showAlertMsg = true;
          this.alertMessage = Object.values(error.error)[0].toString();
        } catch {}
        this.uploading = false;
      },
    );
  }

  addClient() {
    this.clientDialogRef = this.dialog.open(AddClientComponent, {});
    this.clientDialogRef.afterClosed().subscribe((result) => {
      if (result?.id) {
        this.addNewClient(result);
      }
    });
  }

  addNewClient(event) {
    this.getClients(this.params + '1');
    setTimeout(() => {
      this.buildingDetailsFormGroup.patchValue({ order_client: event?.id });
    }, 200);
  }

  codeValueChanged(event) {
    this.buildingDetailsFormGroup.get(event.labelEn).setValue(event.value);
  }

  hideErrorMsg() {
    this.showAlertMsg = false;
  }

  onShortAddressInput() {
    const control = this.buildingDetailsFormGroup.get('property_unit')?.get('short_address');
    if (control?.value) {
      control.setValue(control.value.toUpperCase(), { emitEvent: false });
    }
  }

  setRefrenceData(linked_order: { id: number } | null) {
    this.buildingDetailsFormGroup.get('linked_order')?.setValue(linked_order?.id);
  }

  getRefrenceNumberByParams(params: { clearList?: boolean; params: Record<string, unknown> }) {
    if (params.clearList) {
      this.referenceNumberList = [];
      this.mainOrders = [];
      this.buildingDetailsFormGroup.get('linked_order')?.setValue(null);
    }
    this.getReferenceNumberOrders(params.params);
  }

  getReferenceNumberOrders(params: Record<string, unknown>) {
    this.orderService.getRefrenceNumbers(params).subscribe(
      (data) => {
        this.mainOrders.push(...data.results);
        this.referenceNumberList = [...this.mainOrders];
        this.refrencePageCount = data.pages_count;
      },
      () => {},
    );
  }

  getClientGoals() {
    this.orderService.getClientGoals().subscribe((data) => {
      this.clientGoals = data;
    });
  }
}
